import React, { useRef, useEffect, useState } from 'react';
import styles from './FirstScreen.module.css';
import ContactForm from '../SecondReceptionistComponents/form/form';
import FloatingButton from '../SecondReceptionistComponents/floatingButton/floatingButton';
import Popped from '../SecondReceptionistComponents/poppedUpWindow/Popped';
import logoHamisrad from '../recImages/logoHamisrad.png';
import moneyVideo from '../recImages/money.mp4';

const FirstScreenRec = () => {
  const videoRef = useRef(null);
  const [isPoppedOpen, setIsPoppedOpen] = useState(false);

  useEffect(() => {
    // Ensure video plays and loops
    if (videoRef.current) {
      videoRef.current.play().catch(err => {
        console.log('Video autoplay prevented:', err);
      });
    }
  }, []);

  const handleButtonClick = () => {
    setIsPoppedOpen(true);
  };

  return (
    <>
      <div className={styles.heroContainer} dir="rtl">
        {/* Background Video */}
        <div className={styles.videoBackground}>
          <video
            ref={videoRef}
            className={styles.backgroundVideo}
            autoPlay
            muted
            loop
            playsInline
          >
            <source src={moneyVideo} type="video/mp4" />
          </video>
        </div>

        <div className={styles.contentWrapper}>
          <div className={styles.contentSection}>
            <div className={styles.textContent}>
              <div className={styles.logoContainer}>
                <img src={logoHamisrad} alt="המשרד לוגו" className={styles.logo} />
              </div>
              <h1 className={styles.title}>
                לבנות עסק ניהול ואדמיניסטרציה שמכניס 5 ספרות בחודש בתנאים שלך
              </h1>
              <p className={styles.subtitle}>
                בתוכנית לימוד וליווי מעשית, תלמדי שלב אחר שלב איך להקים עסק ניהול ואדמיניסטרציה עצמאי ורווחי
                <br />
                עם שיטה ברורה, ביטחון מקצועי ותוכנית עבודה שאפשר ליישם מהיום הראשון.
              </p>
              <button 
                className={styles.glassButton}
                onClick={handleButtonClick}
              >
                אני רוצה לשמוע עוד
              </button>
            </div>
          </div>
        </div>
      </div>
      
      {isPoppedOpen && <Popped onClose={() => setIsPoppedOpen(false)} />}

      {/* Form Section Below */}
      <div className={styles.formSectionWrapper}>
        <ContactForm />
      </div>

      {/* Floating Button */}
      <FloatingButton />
    </>
  );
};

export default FirstScreenRec;


